<template>
  <v-text-field
    :hide-details="hideDetails"
    overflow
    label="Auslösung"
    :value="internalValue"
    :disabled="disabled"
    :loading="loading"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script>
import parseDecimalNumber from 'parse-decimal-number'

const numberFormatter = new Intl.NumberFormat(
  undefined,
  {
    useGrouping: false
  }
)
const currencyFormatter = new Intl.NumberFormat(
  undefined,
  {
    style: 'currency',
    currency: 'EUR'
  }
)

const parse = function (str) {
  if (typeof str === 'number') {
    return str
  } else {
    return parseDecimalNumber(str, '.,')
  }
}

export default {
  props: [
    'disabled',
    'hideDetails',
    'loading',
    'value',
  ],
  data () {
    return {
      dirtyValue: null,
      internalValue: ''
    }
  },
  watch: {
    value () {
      this.updateInternalValue()
    }
  },
  created () {
    this.updateInternalValue()
  },
  methods: {
    onInput (newValue) {
      this.dirtyValue = newValue
    },
    onFocus () {
      if (this.value) {
        const num = parse(this.value)
        if (!isNaN(num)) {
          this.internalValue = numberFormatter.format(num)
        }
      }
    },
    onBlur () {
      const num = parse(this.dirtyValue)
      if (!isNaN(num)) {
        this.$emit('input', num)
      } else if ((this.dirtyValue === null) || (this.dirtyValue.trim().length === 0)) {
        if (this.value !== 0) {
          this.$emit('input', 0)
        }
      }
    },
    updateInternalValue () {
      if (this.value && !isNaN(this.value)) {
        this.internalValue = currencyFormatter.format(parse(this.value))
      } else {
        this.internalValue = ''
      }
      this.dirtyValue = this.internalValue
    }
  }
}
</script>
